import { PAYMENT } from './constants';

const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

export function capitalizeFirstLetter(val) {
    return String(val).charAt(0).toUpperCase() + String(val).slice(1);
}

// UUID v4 with graceful degradation for older browsers. crypto.randomUUID
// only exists in secure contexts on recent browsers, so fall back to
// getRandomValues, then Math.random. For an idempotency token we only need
// uniqueness, not cryptographic strength — so any tier is acceptable.
export function uuidv4() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
    }
    if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
        return ('10000000-1000-4000-8000-100000000000').replace(/[018]/g, (c) =>
            (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
        );
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

export const toIsoString = function(date) {
  var tzo = -date.getTimezoneOffset(),
      dif = tzo >= 0 ? '+' : '-',
      pad = function(num) {
          return (num < 10 ? '0' : '') + num;
      };

  return date.getFullYear() +
      '-' + pad(date.getMonth() + 1) +
      '-' + pad(date.getDate()) +
      'T' + pad(date.getHours()) +
      ':' + pad(date.getMinutes()) +
      ':' + pad(date.getSeconds()) +
      dif + pad(Math.floor(Math.abs(tzo) / 60)) +
      ':' + pad(Math.abs(tzo) % 60);
}

export const isEqualObj = function(obj1, obj2) {
  return JSON.stringify(obj1) === JSON.stringify(obj2) 
}
export const isEqualStr = function(str1, str2) {
  if ( (typeof str1 === 'string' || str1 instanceof String) && (typeof str1 === 'string' || str1 instanceof String) ) {
    return str1.toUpperCase() === str2.toUpperCase();
  } else {
    throw Error('Not string!');
  }
}

export const isNumeric = function (str) {
  if (typeof str != "string") return false // we only process strings!  
  return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
         !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
}

export const CARD_FEES = ( () => {
  if ( window['_EZCL'] ) {
    let dualPricing = window['_EZCL']?.data?.dualpricing || window['_EZCL']?.data?.ordering?.dualpricing;
    if ( dualPricing ) {
      let rawFees = window?._EZCL?.data?.ordering?.fees;
      let fees = typeof rawFees == 'number'
        ? rawFees
        : parseFloat(rawFees);
      // console.debug('CARD FEES', fees);
      return fees / 100; // percentages in float value
    }
    return 0;
  }
  return 0;
})();

export const BASE_PRICE_TYPE = (() => (window['_EZCL']?.data?.ordering?.sourcePrice ? window['_EZCL']?.data?.ordering?.sourcePrice : PAYMENT.CARD))();

/* Debug info */
export function displayInitialInfo() {
  if ( window['_EZCL'] ) {
    let dualPricing = window['_EZCL']?.data?.dualpricing || window['_EZCL']?.data?.ordering?.dualpricing;
    if ( dualPricing ) {
      let rawFees = window?._EZCL?.data?.ordering?.fees;
      let discount = 0;
      let fees = typeof rawFees == 'number'
        ? rawFees
        : parseFloat(rawFees);
      discount = (100 - ( 100 / (1 + (fees / 100) )));
      let strategy = BASE_PRICE_TYPE === PAYMENT.CARD ? 'Cash Discount' : 'Card Raising';
      let sign = BASE_PRICE_TYPE === PAYMENT.CARD ? '-' : '+';
      let icon = BASE_PRICE_TYPE === PAYMENT.CARD ? '💳' : '💵';
      let size = BASE_PRICE_TYPE === PAYMENT.CARD ? discount.toFixed(3).replace(/0+$/, "") : fees.toFixed(3).replace(/0+$/, "");

      console.log(`%cDualpricing%c: enabled\n%cBase%c: %s %s\n%cStrategy%c: %s by %c%s%s%%%c`,
                  ...['font-weight: 600;', 'font-weight: 400;'],
                  ...['font-weight: 600;', 'font-weight: 400;'], icon, capitalizeFirstLetter(BASE_PRICE_TYPE),
                  ...['font-weight: 600;', 'font-weight: 400;'], strategy, 'font-weight: 600; color: green;' , sign, size, 'font-weight: 400; color: initial;'
                ); 
    }
  }
}

export const loadExternalScript = function (src) { // eslint-disable-line no-param-reassign
  return new Promise(function (resolve, reject) {
    let shouldAppend = false;
    let element = document.querySelector('script[src="' + src + '"]');
    if (!element) {
      element = document.createElement('script');
      element.type = 'text/javascript';
      element.async = true;
      element.src = src;
      shouldAppend = true;
    }
    else if (element.hasAttribute('data-loaded')) {
      resolve(element);
      return;
    }

    element.addEventListener('error', reject);
    element.addEventListener('abort', reject);
    element.addEventListener('load', () => {
        element.setAttribute('data-loaded', true);
      resolve(element);
    });

    if (shouldAppend) document.head.appendChild(element);
  });
}

export const unloadExternalScript = function (src) { // eslint-disable-line no-param-reassign
  return new Promise(function (resolve, reject) {
    const element = document.querySelector('script[src="' + src + '"]');
    if (!element) { reject(); return; }
    document.head.removeChild(element);
    resolve();
  });
}

export const toCurrency = ( value ) => formatter.format(value)
export const toDollars = ( value ) => (value / 100)
export const toDollarsCurrency = ( value ) => toCurrency( toDollars(value) )

export const convertCentsToDollars = ( cents ) => (cents / 100);

export const getCashDiscounted = ( cents ) => Math.round(cents / (1 + CARD_FEES));
export const getCashDiscountAmount = ( cents ) => (cents - Math.round(cents / (1 + CARD_FEES) ));

export const getCardRaised = ( cents ) => Math.round(cents * (1 + CARD_FEES));
export const getCardRaisedAmount = ( cents ) => (cents - Math.round(cents * (1 + CARD_FEES) ));

export const getCashPrice = (cents) => {
  switch (BASE_PRICE_TYPE) {
    case PAYMENT.CASH:
      return cents;
    case PAYMENT.CARD:
      return getCashDiscounted(cents)
    default:
      return cents;
  }
}
export const getCardPrice = (cents) => {
  switch (BASE_PRICE_TYPE) {
    case PAYMENT.CASH:
      return getCardRaised(cents)
    case PAYMENT.CARD:
      return cents;
    default:
      return cents;
  }
}

export const getPrettyPrice = ( cents ) => formatter.format( convertCentsToDollars(cents) );

export const hashCode = (str, seed = 0, hex = false) => {
  let h1 = 0xdeadbeef ^ seed, h2 = 0x41c6ce57 ^ seed;
  for(let i = 0, ch; i < str.length; i++) {
      ch = str.charCodeAt(i);
      h1 = Math.imul(h1 ^ ch, 2654435761);
      h2 = Math.imul(h2 ^ ch, 1597334677);
  }
  h1  = Math.imul(h1 ^ (h1 >>> 16), 2246822507);
  h1 ^= Math.imul(h2 ^ (h2 >>> 13), 3266489909);
  h2  = Math.imul(h2 ^ (h2 >>> 16), 2246822507);
  h2 ^= Math.imul(h1 ^ (h1 >>> 13), 3266489909);

  let num = 4294967296 * (2097151 & h2) + (h1 >>> 0); 
  if (hex) {
    return BigInt(num).toString(16).toUpperCase();
  } else {
    return num;
  }
}

// export const dateFormat = (value) => {
//   let mm = value.getMonth() + 1;
//   if (mm < 10) mm = '0' + '' + mm;
//   let dd = value.getDate();
//   if (dd < 10) dd = '0' + '' + dd;
//   return '' + value.getFullYear() + '-' + mm + '-' + dd + '';
// }

// export const parseHHMMPair = function(timeString) {
//   if ( !(typeof timeString === 'string' || timeString instanceof String) || !timeString.includes(':') ) {
//       return null;
//   }
//   let tsp = timeString.split(":");
//   if (typeof tsp[0] !== 'undefined' &&
//       tsp[0].length > 0 && tsp[0].length <= 2 && parseInt(tsp[0], 10) >= 0 && parseInt(tsp[0], 10) <= 24 && // hour correctness
//       typeof tsp[1] !== 'undefined' &&
//       tsp[1].length == 2 && parseInt(tsp[1], 10) >= 0 && parseInt(tsp[1], 10) <= 60 // hour minutes
//   ) {
//       return [parseInt(tsp[0], 10), parseInt(tsp[1], 10)]; // H, M array
//   } else {
//       return null;
//   }
// }

export function convertTsToLocal(timestamp) {
  if (timestamp instanceof Date) {
    const d = new Date(timestamp);
  } else if (Number.isInteger(timestamp)) {
    const d = timestamp;
  }

  const yyyy = d.getFullYear();
  const mm   = String(d.getMonth() + 1).padStart(2, '0');
  const dd   = String(d.getDate()).padStart(2, '0');

  const hh   = String(d.getHours()).padStart(2, '0');
  const min  = String(d.getMinutes()).padStart(2, '0');

  return {
    date: `${yyyy}-${mm}-${dd}`,
    time: `${hh}:${min}`,
  };
}

export const toCanonical24 = (t) => {
  const [ h, m ] = parseTimeHHMM(t)
  return `${String(h).padStart(2,'0')}:${String(m).padStart(2,'0')}`
}
export const toAmPm = (t) => {
  const [ h, m ] = parseTimeHHMM(t)
  const suffix = h >= 12 ? 'PM' : 'AM'
  const h12 = (h % 12 === 0) ? 12 : (h % 12)
  return `${h12}:${String(m).padStart(2,'0')} ${suffix}`
}

/**
 * Parses a time string in HH:MM format into an array [hour, minute].
 * @param {string} timeString - The time string to parse (e.g., "8:00", "21:30").
 * @returns {Array<number>|null} An array [hour, minute] or null if parsing fails.
 */
export const parseTimeHHMM = (timeString) => {
  if (typeof timeString !== 'string' || !timeString.includes(':')) {
    console.error("Invalid time string format (must be string with ':'):", timeString);
    return null;
  }

  const parts = timeString.split(':');
  if (parts.length !== 2) {
    console.error("Invalid time string format (must have one ':'):", timeString);
    return null;
  }

  const hourStr = parts[0];
  const minuteStr = parts[1];

  // Используем Number.isInteger для более строгой проверки
  const hour = parseInt(hourStr, 10);
  const minute = parseInt(minuteStr, 10);

  // Проверяем, что парсинг удался и значения находятся в допустимых пределах
  if (
    !Number.isInteger(hour) || hour < 0 || hour >= 24 || // Часы 0-23
    !Number.isInteger(minute) || minute < 0 || minute >= 60 || // Минуты 0-59
    minuteStr.length !== 2 // Убедимся, что минуты двузначные (e.g., '05', not '5')
    // hourStr.length > 2 не так критично, parseInt справится, но можно добавить для строгости
  ) {
    console.error("Invalid hour/minute values or format:", timeString);
    return null;
  }

  return [hour, minute];
};

/**
 * Parses a time range string like "HH:MM-HH:MM" into start and end times.
 * @param {string} scheduleString - The schedule string (e.g., "8:00-22:00").
 * @returns {{startTime: Array<number>, endTime: Array<number>}|null} Object with start/end [h, m] arrays or null.
 */
export const parseStableSchedule = (scheduleString) => {
  if (typeof scheduleString !== 'string' || !scheduleString.includes('-')) {
     console.error("Invalid schedule string format (must be string with '-'):", scheduleString);
    return null;
  }
  const parts = scheduleString.split('-');
  if (parts.length !== 2) {
     console.error("Invalid schedule string format (must have one '-'):", scheduleString);
    return null;
  }

  const startTime = parseTimeHHMM(parts[0]);
  const endTime = parseTimeHHMM(parts[1]);

  if (!startTime || !endTime) {
    return null; // Ошибка уже выведена в parseTimeHHMM
  }

  // Доп. проверка: время начала не может быть позже времени конца (для одного дня)
  if (startTime[0] > endTime[0] || (startTime[0] === endTime[0] && startTime[1] >= endTime[1])) {
      console.error("Start time cannot be later than or equal to end time:", scheduleString);
      return null;
  }


  return { startTime, endTime };
};

export const cw = (c, fw) => {
  let stylePair = ['', ''];
  if (c || fw) {
    stylePair[1] = 'font-weight: initial; color: initial';
    let fontWeight = fw || 600;
    let color = c || 'initial';
    stylePair[0] = `font-weight: ${fontWeight}; color: ${color};`
  }
  return stylePair;
}

/** попадает ли текущее время в интервал (учитываем «через полночь») */
export function inRange (from, to, nowMin) {
  const [fh,fm] = from.split(':').map(Number)
  const [th,tm] = to.split(':').map(Number)
  let start = fh * 60 + fm
  let end   = th * 60 + tm
  if (end <= start) end += 1440      // интервал «через ночь»
  if (nowMin < start) nowMin += nowMin < start ? 0 : 1440
  return nowMin >= start && nowMin < end
}

export const WEEK_DAYS = ['sun','mon','tue','wed','thu','fri','sat']

export function extractAxiosErrorMessage(error) {
    // HTTP error from server
    if (error?.response?.data?.message) {
      return error.response.data.message;
    }
    
    // local JS error or manually thrown Error
    if (error instanceof Error && error.message) {
        return error.message;
    }

    return 'Request failed.';
}
export function hexToRgb(hex) {
  hex = hex.replace(/^#/, '');
  if (hex.length === 3) {
    hex = hex.split('').map(c => c + c).join('');
  }

  const bigint = parseInt(hex, 16);

  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;

  return { r, g, b };
}